import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';
// 		   'home' => 0,
//         'day' => 1,
//         'alumni' => 2,
//         'orientation' => 3,
//         'international' => 4,
//         'company' => 5,
//         'data' => 6

const destacados = {
	state: {
		destacados : []
	},
	getters: {
		getDestacados: (state) => (position) => {
			if(state.destacados.length != 0){
				if(!!position){
					return state.destacados.filter(n => {
						if(!!n.position){
							return n.position.includes(String(position))
						}
					});
				}else{
					return state.destacados;
				}

				console.log(state.destacados);
				
			}else{
				return null;
			}
		},
	},
	actions: {
		requestDestacados: ({ commit },) => {
			return new Promise((resolve, reject) => {

				axios.get(`api/featured`)
					.then(response => {
						commit('setDestacados', response.data);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
	},
	mutations: {
		setDestacados: (state, destacados) => {
			state.destacados = destacados;
		},
	}
}

export default destacados;



// WEBPACK FOOTER //
// ./src/store/destacados.js